/* AquaPrivée Theme JS — v1.0.0 */

/* ── Slider draggable ── */
function initSlider(el) {
  if (!el) return;
  let drag = false, startX = 0, scrollLeft = 0;
  el.addEventListener('mousedown', e => { drag = true; startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft; el.style.cursor = 'grabbing'; });
  window.addEventListener('mouseup', () => { drag = false; el.style.cursor = 'grab'; });
  el.addEventListener('mousemove', e => { if (!drag) return; e.preventDefault(); el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 1.2; });
  el.addEventListener('touchstart', e => { startX = e.touches[0].pageX; scrollLeft = el.scrollLeft; }, { passive: true });
  el.addEventListener('touchmove', e => { el.scrollLeft = scrollLeft - (e.touches[0].pageX - startX) * 1.2; }, { passive: true });
}

/* ── Tags ── */
function getPoolTags(title) {
  const t = title.toLowerCase(), tags = [];
  if (/chauff|heated|28°|30°|31°/.test(t)) tags.push('Chauffée');
  if (/intér|indoor|couverte|covered/.test(t)) tags.push('Intérieure');
  if (/jacuzzi|spa priv|hot tub/.test(t)) tags.push('Jacuzzi');
  if (/\bsel\b|saltwater|salée|saline/.test(t)) tags.push('Eau salée');
  if (/pool house|poolhouse/.test(t)) tags.push('Pool house');
  if (tags.length === 0) tags.push('Extérieure');
  return tags;
}

/* ── Notation ── */
function getPoolRating(productId) {
  const seed = productId.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return { score: (4.1 + (seed % 9) * 0.1).toFixed(1), count: 3 + (seed % 50) };
}

/* ── Filtres collection ── */
function initCollectionFilters() {
  const chips = document.querySelectorAll('.filter-chip[data-filter]');
  const cards = document.querySelectorAll('.product-card[data-title]');
  const regionSel = document.getElementById('region-filter');
  const priceSel = document.getElementById('price-filter');
  const searchInput = document.getElementById('collection-search');
  const countEl = document.getElementById('collection-count');
  let activeType = 'all';

  function filterCards() {
    const q = (searchInput?.value || '').toLowerCase();
    const region = regionSel?.value || '';
    const priceMax = parseInt(priceSel?.value || '0') || 0;
    let visible = 0;
    cards.forEach(card => {
      const title = (card.dataset.title || '').toLowerCase();
      const cardRegion = card.dataset.region || '';
      const price = parseFloat(card.dataset.price || '0');
      const tags = (card.dataset.tags || '').toLowerCase();
      let show = true;
      if (q && !title.includes(q) && !cardRegion.toLowerCase().includes(q)) show = false;
      if (region && cardRegion !== region) show = false;
      if (priceMax > 0 && price > priceMax) show = false;
      if (activeType !== 'all' && !tags.includes(activeType)) show = false;
      card.closest('.card-wrapper')?.style?.setProperty('display', show ? '' : 'none');
      if (show) visible++;
    });
    if (countEl) countEl.textContent = `${visible} piscine${visible > 1 ? 's' : ''}`;
  }

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      activeType = chip.dataset.filter;
      filterCards();
    });
  });

  regionSel?.addEventListener('change', filterCards);
  priceSel?.addEventListener('change', filterCards);
  searchInput?.addEventListener('input', filterCards);

  // Init count
  if (countEl) countEl.textContent = `${cards.length} piscine${cards.length > 1 ? 's' : ''}`;
}

/* ── Booking widget ── */
function initBookingWidget(pricePerPerson) {
  const SLOTS = ['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00'];
  let selectedSlot = -1, adults = 2, kids = 0, babies = 0;

  // Générer les créneaux
  const slotsGrid = document.getElementById('slots-grid');
  if (slotsGrid) {
    const productId = document.querySelector('[data-product-id]')?.dataset.productId || '1';
    const seed = productId.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
    slotsGrid.innerHTML = SLOTS.map((s, i) => {
      const unavail = (seed * 31 + i * 17) % 5 === 0;
      return `<div class="time-slot${unavail ? ' unavailable' : ''}" data-index="${i}" data-time="${s}">${s}</div>`;
    }).join('');
    slotsGrid.addEventListener('click', e => {
      const slot = e.target.closest('.time-slot');
      if (!slot || slot.classList.contains('unavailable')) return;
      document.querySelectorAll('.time-slot').forEach(s => s.classList.remove('selected'));
      slot.classList.add('selected');
      selectedSlot = parseInt(slot.dataset.index);
      updateTotal();
    });
  }

  // Guest controls
  document.querySelectorAll('[data-guest-action]').forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.guestAction;
      const type = btn.dataset.guestType;
      if (type === 'adults') adults = Math.max(0, adults + (action === 'plus' ? 1 : -1));
      else if (type === 'kids') kids = Math.max(0, kids + (action === 'plus' ? 1 : -1));
      else babies = Math.max(0, babies + (action === 'plus' ? 1 : -1));
      document.getElementById('count-adults').textContent = adults;
      document.getElementById('count-kids').textContent = kids;
      document.getElementById('count-babies').textContent = babies;
      updateTotal();
    });
  });

  // Set today's date
  const dateInput = document.getElementById('booking-date');
  if (dateInput) {
    dateInput.value = new Date().toISOString().split('T')[0];
    dateInput.addEventListener('change', updateTotal);
  }

  function updateTotal() {
    const rows = document.getElementById('total-rows');
    const btn = document.getElementById('booking-submit');
    const dateVal = dateInput?.value;
    if (selectedSlot < 0 || !dateVal || (adults + kids) === 0) {
      if (rows) rows.innerHTML = '<div class="total-row"><span>Sélectionnez une date et un créneau</span><span>—</span></div>';
      if (btn) btn.disabled = true;
      return;
    }
    const slot = SLOTS[selectedSlot];
    const nextH = String(parseInt(slot) + 1).padStart(2, '0');
    const slotLabel = `${slot}–${nextH}:00`;
    const adultTotal = adults * pricePerPerson;
    const kidTotal = kids * (pricePerPerson * 0.5);
    const subtotal = adultTotal + kidTotal;
    const fees = Math.round(subtotal * 0.05 * 100) / 100;
    const total = Math.round((subtotal + fees) * 100) / 100;
    const d = new Date(dateVal);
    const dateStr = d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
    if (rows) rows.innerHTML = `
      <div class="total-row"><span>${dateStr} · ${slotLabel}</span><span></span></div>
      ${adults > 0 ? `<div class="total-row"><span>${adults} adulte${adults > 1 ? 's' : ''} × ${pricePerPerson} €</span><span>${adultTotal} €</span></div>` : ''}
      ${kids > 0 ? `<div class="total-row"><span>${kids} enfant${kids > 1 ? 's' : ''} × ${(pricePerPerson * 0.5).toFixed(0)} €</span><span>${kidTotal.toFixed(0)} €</span></div>` : ''}
      ${babies > 0 ? `<div class="total-row"><span>${babies} bébé${babies > 1 ? 's' : ''}</span><span>Gratuit</span></div>` : ''}
      <div class="total-row"><span>Frais de service</span><span>${fees.toFixed(2)} €</span></div>
      <div class="total-row grand-total"><span>Total</span><span>${total.toFixed(2)} €</span></div>`;
    if (btn) btn.disabled = false;
  }
}

/* ── Nav scroll ── */
function initNav() {
  const nav = document.querySelector('.site-nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', () => {
  initNav();
  document.querySelectorAll('.cards-slider').forEach(initSlider);
  initCollectionFilters();
  const priceEl = document.querySelector('[data-price-per-person]');
  if (priceEl) initBookingWidget(parseFloat(priceEl.dataset.pricePerPerson));
});
